import React from 'react';
import { Text, FlexRow, SvgIcon, FilledButton } from '@make-software/tg-mini-app-ui';

import { openLink } from '@/utils';
import { HOW_VOTING_WORKS_URL } from '@/constants';
import { Round2ActivityCard, PageWrapper, TitleRow, LoadingState } from '@/shared';
import InfoIcon from '@/shared/assets/icons/ic-info.svg';

import { Container } from './styled';
import { OnChain } from './components';
import { useScreen } from './useScreen';
import { ActivityList } from './components/activity-list';

export const Activity: React.FC = () => {
  const { round1Items, round2Items, loading, loadMore, hasMore, airdropInfo } = useScreen();

  const currentRound = window.config.rounds === '1' ? 1 : airdropInfo?.airdrop?.round ?? 1;
  const isRound1 = currentRound === 1;

  const showRound1Section = isRound1 || (round1Items?.length ?? 0) > 0;

  return (
    <PageWrapper padding="0 16px 20px 16px">
      <TitleRow weight={3} color="#FFFFFF" margin="10px 0px 0px 0px">
        Your on-chain activity
      </TitleRow>

      <OnChain />

      <FilledButton
        margin="20px 0px 0px 0px"
        onClick={openLink(HOW_VOTING_WORKS_URL)}
        title={
          <FlexRow gap={5} align="center">
            <SvgIcon src={InfoIcon} size={24} color="#FFF" />
            <Text size={'md'} color="#FFFFFF">
              Click here to learn more about FAN token
            </Text>
          </FlexRow>
        }
      />

      {loading ? (
        <LoadingState />
      ) : (
        <>
          {showRound1Section && (
            <>
              <TitleRow size={'md'} color="#FFFFFF">
                Qualification Round
              </TitleRow>

              <ActivityList
                items={round1Items}
                round={1}
                hasMore={isRound1 ? hasMore : false}
                onLoadMore={loadMore}
              />
            </>
          )}

          {window.config.rounds === '2' && <TitleRow size="md" color="#FFFFFF">
            Round 2 - Final
          </TitleRow>}

          {isRound1 && window.config.rounds === '2' ? (
            <Container gap={10}>
              <Round2ActivityCard
                startsAt={airdropInfo?.airdrop?.next_round_starts_on}
                withCountdown
              />
            </Container>
          ) : (<>
              {window.config.rounds === '2'
                ? <ActivityList items={round2Items} round={2} hasMore={hasMore} onLoadMore={loadMore} />
                : null}
            </>
          )}
        </>
      )}
    </PageWrapper>
  );
};
